// This file was auto-generated by Fern from our API Definition.
export var Windowing;
(function (Windowing) {
    Windowing.Order = {
        Ascending: "ascending",
        Descending: "descending",
    };
})(Windowing || (Windowing = {}));
